import { createHmac } from 'crypto'

export function sign (key, buffer, algo = 'sha512', encoding = 'base64') {
  return createHmac(algo, key).update(buffer).digest(encoding)
}
